import React, { useState, useEffect } from "react";
import DashboardNav from "../DashboardNav/DashboardNav";
import DashboardSidebar from "../DashboardSidebar/DashboardSidebar";
import DealsManagement from "./DealsSection/DealsSection";
import DealApproval from "./DealApprovalSection/DealApprovalSection"
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import { useLocation } from "react-router-dom";

const MainPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 991);
  const { state } = useLocation()

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 991 && isSidebarOpen) {
        setIsSidebarOpen(false);
      } else if (window.innerWidth >= 991 && !isSidebarOpen) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isSidebarOpen]);

  return (
    <>
      <DashboardSidebar isOpen={isSidebarOpen} />
      <DashboardNav
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
      />
      <div className="dashboard-layout">
        <div
          className={`main-section ${
            isSidebarOpen ? "sidebar-open" : "sidebar-closed"
          }`}
        >
          <div className="main-dashboard-page-content">
            <Breadcrumbs
              items={
                [
                  { label: "Deals Management", href: "/merchant-management" },
                  { label: "Deal Approval" },

              ]}
            />
            <div className="row gap-4">
              <div className="col-12">
                <DealApproval deal={state.deal}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainPage;
